export function getGraphqlProxyUrl(localesQuery?: string) {
  if (typeof window === "undefined") {
    return `${process.env.INTERNAL_SITE_URL}/api/graphql-proxy/${localesQuery || ""}`;
  } else {
    return `/api/graphql-proxy/${localesQuery || ""}`;
  }
}
